import { observer } from "mobx-react";
import React from "react";
import { VerticalSeparator } from "../../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import styles from "../../taggingSettings.css";
import { ExistingMappingFormType } from "../../types";
import { ActiveCheckbox } from "../activeCheckbox/ActiveCheckbox";
import { FormTag } from "../formTag/formTag";
import { TaggingStrategy } from "../taggingStrategy/taggingStrategy";

interface Props {
  form: ExistingMappingFormType;
  isEdited: boolean;
}
export const MappingBox = observer(({ isEdited, form }: Props) => {
  return (
    <div className={styles["form-content"]}>
      <TaggingStrategy form={form} isEdited={isEdited} />
      <VerticalSeparator />
      <FormTag form={form.$.tag} isEdited={isEdited} />
      {!isEdited && (
        <>
          <VerticalSeparator />
          <div className={styles["checkbox-group"]}>
            <ActiveCheckbox field={form.$.enabled} id={form.$.id.$} noMarginBottom />
          </div>
        </>
      )}
    </div>
  );
});
